import classnames from 'classnames/bind';
import styles from './Skeleton.module.scss';

const cx = classnames.bind(styles);

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  variant?: 'rectangular' | 'text' | 'circular';
  animation?: 'shimmer' | 'none';
  className?: string;
  'data-testid'?: string;
}

const Skeleton = ({
  width,
  height,
  variant = 'rectangular',
  animation = 'shimmer',
  className,
  'data-testid': dataTestId,
}: SkeletonProps) => (
  <div
    className={cx('skeleton', variant, { 'no-animation': animation === 'none' }, className)}
    style={{ width, height }}
    data-testid={dataTestId ?? 'skeleton'}
    aria-hidden="true"
  />
);

export default Skeleton;
